import { render, staticRenderFns } from "./partners-section.vue?vue&type=template&id=280ab18b&scoped=true&"
import script from "./partners-section.vue?vue&type=script&lang=js&"
export * from "./partners-section.vue?vue&type=script&lang=js&"
import style0 from "./partners-section.vue?vue&type=style&index=0&id=280ab18b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280ab18b",
  null
  
)

export default component.exports